/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Offer } from './Offer';
import {
    OfferFromJSON,
    OfferFromJSONTyped,
    OfferToJSON,
} from './Offer';

/**
 * 
 * @export
 * @interface CreateOfferResponse
 */
export interface CreateOfferResponse {
    /**
     * 
     * @type {Offer}
     * @memberof CreateOfferResponse
     */
    offer: Offer;
}

/**
 * Check if a given object implements the CreateOfferResponse interface.
 */
export function instanceOfCreateOfferResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "offer" in value;

    return isInstance;
}

export function CreateOfferResponseFromJSON(json: any): CreateOfferResponse {
    return CreateOfferResponseFromJSONTyped(json, false);
}

export function CreateOfferResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOfferResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'offer': OfferFromJSON(json['offer']),
    };
}

export function CreateOfferResponseToJSON(value?: CreateOfferResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'offer': OfferToJSON(value.offer),
    };
}

